<script lang="ts">
	import type { IconName } from '$lib/components/icons/types';
	import type { PoiSummaryScheme } from '$lib/components/pois/types';
	import PoiSummaryImage from './PoiSummaryImage.svelte';

	export let name: string;
	export let color: PoiSummaryScheme;
	export let icon: IconName | undefined = undefined;
	export let imageUrl: string | null = null;

	const infosClasses: Record<PoiSummaryScheme, string> = {
		hotel: 'text-hotel rowformattedinfos',
		hotelMichelin: 'text-hotel-michelin rowformattedinfos',
		restaurant: 'text-restaurant rowformattedinfos',
		restaurantMichelin: 'text-restaurant-michelin rowformattedinfos',
		tourism: 'text-tourism rowformattedinfos',
		parking: 'text-coloredneutral rowformattedinfos compactrows',
		rest: 'text-coloredneutral rowformattedinfos compactrows',
		energy: 'text-coloredneutral',
	};
</script>

<div
	class="poi-summary flex flex-row gap-1 relative rd-2 shadow-subtle p-1 bg-neutral-weakest w-full"
>
	{#if imageUrl !== null}
		{#if imageUrl}
			<PoiSummaryImage src={imageUrl} {icon} {color} />
		{/if}
	{/if}

	<div class="flex flex-col pt-1 px-1 min-w-0 flex-grow" class:pb-1={imageUrl === null}>
		<div class="truncate text-md text-bold text-coloredneutral">
			{name}
		</div>
		{#if $$slots.infos}
			<div class="flex flex-col text-sm flex-grow {infosClasses[color]}">
				<slot name="infos" />
			</div>
		{/if}
		<div class="flex flex-row justify-between w-full">
			{#if $$slots.buttons}
				<div class="flex flex-row gap-2 mt-2">
					<slot name="buttons" />
				</div>
			{/if}
			{#if $$slots.note}
				<div class="flex flex-row gap-2 mt-2">
					<slot name="note" />
				</div>
			{/if}
		</div>
	</div>
</div>

<style>
	.rowformattedinfos > :global(div) {
		height: 24px;
		display: flex;
		flex-direction: row;
		align-items: center;
	}

	.compactrows > :global(div) {
		height: 20px;
	}
</style>
